<main class="partners-page">
  <div class="top-row">
    <button type="button" class="back-btn" [attr.aria-label]="'partners.backAria' | translate" (click)="goBack()">
      <sz-icon name="arrow-back" [size]="20" />
    </button>
    <sz-brand-block [compact]="true" />
  </div>

  <div class="partners-head">
    <div class="partners-head__kicker">
      <span>{{ 'partners.kicker' | translate }}</span>
    </div>
    <h1 class="partners-head__title">
      {{ 'partners.titleMain' | translate }}
      <span class="partners-head__accent">{{ 'partners.titleAccent' | translate }}</span>
    </h1>
    <p class="partners-head__intro">{{ 'partners.subtitle' | translate }}</p>
  </div>

  @for (partner of list; track partner.id) {
    <sz-partner-card
      variant="feed"
      [logoFull]="true"
      [clickable]="true"
      [logoSrc]="partner.logoSrc"
      [logoAlt]="partner.name"
      [accent]="partner.accentColor"
      [ctaAria]="'partners.' + partner.id + '.cta' | translate"
      (action)="goToPartner(partner.id)" />
  }
</main>
